/*
  YAZNE shopping helpers on every page (color dots, favorites, recently viewed): see snippets/yazne-favorites.liquid
  for what each one does. Loaded with defer so browsers cache it; the snippet passes the page's own data
  (texts, current product, currency, cart URL) in window.yzFavsConfig.
*/
(function () {
  if (window.yzFavs) return;
  window.yzFavs = true;
  var CFG = window.yzFavsConfig || {};
  var T = CFG.t || {};
  var ES = CFG.es === true;
  var CURRENT = CFG.current || '';
  var SHOP_CURRENCY = CFG.currency || 'USD';
  var CART_ADD = CFG.cartAdd || '/cart/add';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FAV = 'yz-favs';
  var REC = 'yz-recent';
  var STAR = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3.2l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.6l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z"/></svg>';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };

  // Colors of the same bag, from the configurator's swatches: [handle, swatch, Spanish, English].
  var GROUPS = [
    [
      ['bolsa-yazne-blanca', '#ffffff', 'Blanca', 'White'],
      ['bolsa-yazne-negra', '#1a1a1a', 'Negra', 'Black'],
      ['bolsa-yazne-azul-cielo-liso', '#a9c6d8', 'Azul cielo liso', 'Sky blue'],
      ['bolsa-yazne-azul-cielo-textura-avestruz', '#7fa8c2', 'Azul cielo avestruz', 'Ostrich blue'],
      ['bolsa-yazne-amarilla', '#e8c547', 'Amarilla', 'Yellow'],
      ['bolsa-yazne-roja', '#b0283a', 'Roja', 'Red'],
      ['bolsa-yazne-wine', '#6e2433', 'Vino', 'Wine'],
      ['bolsa-yazne-pink', '#eab6c6', 'Rosa', 'Pink'],
      ['bolsa-yazne-ivory', '#e6d9bd', 'Ivory', 'Ivory'],
      ['bolsa-yazne-verde-salvia', '#8a9b7d', 'Verde salvia', 'Sage green']
    ],
    [
      ['bolsa-yazne-crema-hueso', '#f3ebdd', 'Crema', 'Cream'],
      ['bolsa-yazne-cafe-caramelo', '#6b4a2e', 'Café', 'Brown'],
      ['bolsa-yazne-vino', '#722f37', 'Vino', 'Wine'],
      ['bolsa-yazne-rosa', '#e8a0b4', 'Rosa', 'Pink']
    ],
    [
      ['bolsa-crossbody-yazne-negra', '#1a1a1a', 'Negra', 'Black'],
      ['bolsa-crossbody-yazne-crema', '#efe8dc', 'Crema', 'Cream'],
      ['bolsa-crossbody-yazne-cafe-caramelo', '#a0582e', 'Caramelo', 'Caramel'],
      ['bolsa-crossbody-yazne-vino', '#6b1f2e', 'Vino', 'Wine'],
      ['bolsa-crossbody-yazne-verde-olivo', '#6b7041', 'Verde olivo', 'Olive green'],
      ['bolsa-crossbody-yazne-rosa', '#e8a7b0', 'Rosa', 'Pink']
    ]
  ];

  function load(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function save(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }
  function forget(handle) {
    [FAV, REC].forEach(function (k) { save(k, load(k).filter(function (h) { return h !== handle; })); });
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function url(handle) { return ROOT + 'products/' + handle; }
  // Prices come in the shopper's currency; outside the store currency (e.g. pesos) the code is added.
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || SHOP_CURRENCY;
    return '$' + (cents / 100).toFixed(2) + (cur !== SHOP_CURRENCY ? ' ' + cur : '');
  }
  function sized(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function groupOf(handle) {
    for (var i = 0; i < GROUPS.length; i++) {
      for (var j = 0; j < GROUPS[i].length; j++) if (GROUPS[i][j][0] === handle) return GROUPS[i];
    }
    return null;
  }
  function colorName(entry) { return ES ? entry[2] : entry[3]; }

  /* ---------- Product data ---------- */
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(url(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (res.status === 404) { forget(handle); return null; }
          return res.ok ? res.json() : null;
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  // Card photo at the one width the swap uses, so a warmed photo is exactly the file shown.
  var CARD_W = 800;
  var warmed = {};
  function warm(handle) {
    if (!handle || warmed[handle]) return;
    warmed[handle] = true;
    getProduct(handle).then(function (p) {
      if (p && p.featured_image) new Image().src = sized(p.featured_image, CARD_W);
    });
  }
  function miniHTML(p, withActions) {
    var v = p.variants && p.variants[0];
    var html = '<li class="yz-mini">' +
      '<a class="yz-mini__media" href="' + esc(url(p.handle)) + '" tabindex="-1" aria-hidden="true">' +
        (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 500)) + '" alt="" width="300" height="400" loading="lazy">' : '') +
      '</a>' +
      '<a class="yz-mini__name" href="' + esc(url(p.handle)) + '">' + esc(p.title) + '</a>' +
      '<span class="yz-mini__price">' + money(p.price) + '</span>';
    if (withActions) {
      html += '<button type="button" class="yz-fav" data-yz-fav="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + esc(T.saved + ': ' + p.title) + '">' + STAR + '</button>';
      html += p.available && v
        ? '<button type="button" class="yz-mini__add" data-yz-mini-add="' + v.id + '">+ ' + esc(T.add) + '</button>'
        : '<span class="yz-mini__soldout">' + esc(T.soldout) + '</span>';
    }
    return html + '</li>';
  }
  function renderList(list, handles, withActions) {
    return Promise.all(handles.map(getProduct)).then(function (products) {
      var found = products.filter(Boolean);
      list.innerHTML = found.map(function (p) { return miniHTML(p, withActions); }).join('');
      return found.length;
    });
  }

  /* ---------- Favorites ---------- */
  function toggle(handle) {
    var list = load(FAV);
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    save(FAV, list.slice(0, 60));
    return i < 0;
  }
  function sync() {
    var favs = load(FAV);
    document.querySelectorAll('[data-yz-fav]').forEach(function (btn) {
      var on = favs.indexOf(btn.getAttribute('data-yz-fav')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var text = btn.querySelector('.yz-fav-pill__text');
      if (text) text.textContent = on ? T.saved : T.save;
    });
    document.querySelectorAll('.yz-fav-link').forEach(function (link) {
      link.hidden = favs.length === 0 && !document.querySelector('[data-yz-favs-grid]');
      link.querySelector('.yz-fav-link__count').textContent = favs.length || '';
    });
  }
  function headerLink() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.yz-fav-link')) return;
    var link = document.createElement('a');
    link.className = 'yz-fav-link header-actions__action';
    link.href = ROOT + 'pages/favoritas';
    link.setAttribute('aria-label', T.favs);
    link.innerHTML = STAR + '<span class="yz-fav-link__count" aria-hidden="true"></span>';
    var cart = actions.querySelector('[data-testid="cart-drawer-trigger"]') || actions.lastElementChild;
    actions.insertBefore(link, cart);
  }
  function favButton(handle, name) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yz-fav';
    btn.setAttribute('data-yz-fav', handle);
    btn.setAttribute('aria-label', name ? T.save + ': ' + name : T.save);
    btn.innerHTML = STAR;
    return btn;
  }
  function renderFavoritesPage() {
    var grid = document.querySelector('[data-yz-favs-grid]');
    if (!grid) return;
    var handles = load(FAV);
    var empty = document.querySelector('[data-yz-favs-empty]');
    renderList(grid, handles, true).then(function (count) {
      grid.hidden = count === 0;
      if (empty) empty.hidden = count > 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-yz-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(btn.getAttribute('data-yz-fav'));
    sync();
    if (on) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }
    if (btn.closest('[data-yz-favs-grid]')) renderFavoritesPage();
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key === FAV) { sync(); renderFavoritesPage(); }
  });

  // "+ Add" on the favorites page.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-yz-mini-add]');
    if (!btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    fetch(CART_ADD + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-yz-mini-add')), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function () {
        btn.textContent = T.added;
        btn.setAttribute('data-state', 'added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () { btn.textContent = T.error; })
      .finally(function () {
        setTimeout(function () {
          btn.textContent = label;
          btn.removeAttribute('data-state');
          btn.disabled = false;
        }, 1800);
      });
  });

  /* ---------- Color dots ---------- */
  function dots(group, handle, big) {
    var wrap = document.createElement('div');
    wrap.className = big ? 'yz-dots yz-dots--big' : 'yz-dots';
    wrap.innerHTML = group.map(function (entry) {
      var here = entry[0] === handle;
      return '<a class="yz-dots__dot" href="' + esc(url(entry[0])) + '" data-yz-color="' + esc(entry[0]) + '" style="--c:' + entry[1] + '" title="' + esc(colorName(entry)) + '"' +
        ' aria-label="' + esc(T.color + ': ' + colorName(entry)) + '"' + (here ? ' aria-current="true"' : '') + '></a>';
    }).join('');
    return wrap;
  }
  function markDot(wrap, handle) {
    wrap.querySelectorAll('.yz-dots__dot').forEach(function (d) {
      if (d.getAttribute('data-yz-color') === handle) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }
  // Waits a moment for the new photo so the card doesn't flash empty, but never long: a photo that
  // isn't ready by then simply finishes loading in place.
  function preload(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve();
      var img = new Image();
      img.onload = img.onerror = function () { resolve(); };
      img.src = sized(src, CARD_W);
      if (img.complete) resolve();
      setTimeout(resolve, 250);
    });
  }
  function fadeIn(el) {
    if (reduced.matches || !el || !el.animate) return;
    el.animate([{ opacity: 0.6 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
  }
  // A card's other colors are fetched as soon as the pointer or finger reaches its dots.
  document.addEventListener('pointerover', function (e) {
    var wrap = e.target.closest && e.target.closest('.yz-dots');
    if (!wrap || wrap.hasAttribute('data-yz-warm')) return;
    wrap.setAttribute('data-yz-warm', '');
    wrap.querySelectorAll('.yz-dots__dot').forEach(function (d) { warm(d.getAttribute('data-yz-color')); });
  }, { passive: true });

  // Card: the photos, name, price, links, add button and favourite star switch to the chosen color.
  function swapCard(card, handle, wrap) {
    markDot(wrap, handle);
    getProduct(handle).then(function (p) {
      if (!p) { location.href = url(handle); return; }
      var images = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean);
      preload(images[0]).then(function () {
        var gallery = card.querySelector('.card-gallery');
        card.querySelectorAll('.card-gallery slideshow-slide img').forEach(function (img, i) {
          var src = images[i] || images[0];
          if (!src) return;
          img.removeAttribute('srcset');
          img.src = sized(src, CARD_W);
          img.alt = p.title;
        });
        card.querySelectorAll('a[href*="/products/"]:not(.yz-dots__dot)').forEach(function (a) {
          a.href = url(handle);
          if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', p.title);
        });
        card.querySelectorAll('[role="heading"], .product-grid-view-zoom-out--details h3').forEach(function (el) { el.textContent = p.title; });
        var price = card.querySelector('product-price .price');
        if (price) price.textContent = money(p.price);
        var v = p.variants && p.variants[0];
        if (v) card.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = v.id; });
        card.querySelectorAll('input[name="product-id"]').forEach(function (input) { input.value = p.id; });
        card.querySelectorAll('[data-product-id]').forEach(function (el) { el.setAttribute('data-product-id', p.id); });
        if (card.hasAttribute('data-product-id')) card.setAttribute('data-product-id', p.id);
        card.querySelectorAll('[data-product-title]').forEach(function (el) { el.setAttribute('data-product-title', p.title); });
        card.querySelectorAll('[data-product-variant-media]').forEach(function (el) { el.setAttribute('data-product-variant-media', sized(images[0], 100)); });
        card.querySelectorAll('button[name="add"]').forEach(function (b) { b.disabled = !p.available; });
        var fav = card.querySelector('.yz-fav');
        if (fav) {
          fav.setAttribute('data-yz-fav', handle);
          fav.setAttribute('aria-label', T.save + ': ' + p.title);
        }
        var qv = card.querySelector('.yz-qv');
        if (qv) qv.setAttribute('aria-label', qv.getAttribute('aria-label').split(':')[0] + ': ' + p.title);
        sync();
        fadeIn(gallery);
      });
    });
  }

  // Product page: the main section is re-rendered for the chosen color and put in place of the
  // current one (the theme's custom elements start up again on their own when inserted).
  var sections = {};
  function getSection(handle, id) {
    var key = handle + '|' + id;
    if (!sections[key]) {
      sections[key] = fetch(url(handle) + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
        .then(function (res) { if (!res.ok) throw new Error(); return res.text(); });
      sections[key].catch(function () { delete sections[key]; });
    }
    return sections[key];
  }
  var swapping = false;
  function mainSection() {
    var details = document.querySelector('main .product-details');
    return details && details.closest('.shopify-section');
  }
  function sectionId(sec) { return sec.id.replace(/^shopify-section-/, ''); }
  // Once the page is idle, every color of this bag is fetched (the one on screen too, for coming
  // back to it) so a tap swaps instantly.
  function warmPage() {
    var sec = mainSection();
    var group = groupOf(CURRENT);
    if (!sec || !group) return;
    var id = sectionId(sec);
    idle(function () {
      group.forEach(function (entry) {
        getSection(entry[0], id);
        warm(entry[0]);
      });
    }, { timeout: 3000 });
  }
  function swapPage(handle, push) {
    var sec = mainSection();
    if (!sec || swapping) { location.href = url(handle); return; }
    swapping = true;
    var id = sectionId(sec);
    var oldTitle = '';
    var oldHeading = sec.querySelector('h1');
    if (oldHeading) oldTitle = oldHeading.textContent.trim();
    var row = sec.querySelector('.yz-pcolors .yz-dots');
    if (row) markDot(row, handle);
    var slow = setTimeout(function () {
      if (!reduced.matches) { sec.style.transition = 'opacity 160ms ease'; sec.style.opacity = '0.6'; }
    }, 120);
    getSection(handle, id)
      .then(function (html) {
        clearTimeout(slow);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sec.id);
        if (!fresh) throw new Error();
        sec.replaceWith(fresh);
        if (!reduced.matches && fresh.animate) fresh.animate([{ opacity: 0.6 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
        if (push) history.pushState({ yzColor: handle }, '', url(handle) + location.search);
        var heading = fresh.querySelector('h1');
        if (heading && oldTitle) document.title = document.title.replace(oldTitle, heading.textContent.trim());
        CURRENT = handle;
        save(REC, [handle].concat(load(REC).filter(function (h) { return h !== handle; })).slice(0, 12));
        decorateProduct();
        sync();
      })
      .catch(function () { location.href = url(handle); })
      .finally(function () { swapping = false; });
  }
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.yzColor && e.state.yzColor !== CURRENT) swapPage(e.state.yzColor, false);
  });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.yz-dots__dot');
    if (!dot || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var handle = dot.getAttribute('data-yz-color');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    if (dot.hasAttribute('aria-current')) return;
    var wrap = dot.closest('.yz-dots');
    var card = dot.closest('product-card');
    if (card) swapCard(card, handle, wrap);
    else if (dot.closest('.yz-pcolors')) swapPage(handle, true);
    else location.href = dot.href;
  }, true);

  /* ---------- Product cards ---------- */
  function decorate(card) {
    if (card.hasAttribute('data-yz-fx')) return;
    var handle = handleOf(card);
    if (!handle) return;
    card.setAttribute('data-yz-fx', '');
    var gallery = card.querySelector('.card-gallery');
    var link = card.querySelector('.product-card__link');
    if (gallery) gallery.appendChild(favButton(handle, link ? link.getAttribute('aria-label') : ''));
    var group = groupOf(handle);
    var price = card.querySelector('product-price');
    if (group && price) price.insertAdjacentElement('afterend', dots(group, handle, false));
  }

  /* ---------- Product page ---------- */
  // "Save to favorites" pill and the color row (run again after a color swap re-renders the section).
  function decorateProduct() {
    if (!CURRENT) return;
    var details = document.querySelector('main .product-details');
    if (!details || details.querySelector('.yz-fav-pill')) return;
    var buy = details.querySelector('.buy-buttons-block');
    if (buy) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'yz-fav-pill';
      pill.setAttribute('data-yz-fav', CURRENT);
      pill.innerHTML = STAR + '<span class="yz-fav-pill__text">' + esc(T.save) + '</span>';
      buy.insertAdjacentElement('afterend', pill);
    }
    var group = groupOf(CURRENT);
    var price = details.querySelector('product-price');
    if (group && price) {
      var row = document.createElement('div');
      row.className = 'yz-pcolors';
      var here = group.filter(function (e) { return e[0] === CURRENT; })[0];
      row.innerHTML = '<p class="yz-pcolors__label">' + esc(T.color) + ': <strong>' + esc(colorName(here)) + '</strong></p>';
      row.appendChild(dots(group, CURRENT, true));
      price.insertAdjacentElement('afterend', row);
    }
  }
  function productPage() {
    if (!CURRENT) return;
    history.replaceState(Object.assign({}, history.state, { yzColor: CURRENT }), '');
    decorateProduct();
    warmPage();

    // Recently viewed rail (without this product), then remember this one.
    var seen = load(REC).filter(function (h) { return h !== CURRENT; });
    save(REC, [CURRENT].concat(seen).slice(0, 12));
    var main = document.getElementById('MainContent');
    if (main && seen.length) {
      var section = document.createElement('section');
      section.className = 'yz-recent';
      section.innerHTML = '<h2 class="yz-recent__title">' + esc(T.recent) + '</h2><ul class="yz-mini-rail" role="list"></ul>';
      main.appendChild(section);
      renderList(section.querySelector('ul'), seen.slice(0, 8), false).then(function (count) {
        if (!count) section.remove();
      });
    }
  }

  /* ---------- Empty cart drawer ---------- */
  function fillDrawer() {
    var seen = load(REC).slice(0, 6);
    if (!seen.length) return;
    document.querySelectorAll('[data-cart-drawer-empty]').forEach(function (wrap) {
      if (wrap.querySelector('.yz-recent')) return;
      var section = document.createElement('div');
      section.className = 'yz-recent yz-recent--drawer';
      section.innerHTML = '<p class="yz-recent__title">' + esc(T.recent) + '</p><ul class="yz-mini-rail" role="list"></ul>';
      wrap.appendChild(section);
      renderList(section.querySelector('ul'), seen, false).then(function (count) {
        if (!count) section.remove();
      });
    });
  }

  function scan() {
    document.querySelectorAll('product-card').forEach(decorate);
    fillDrawer();
    sync();
  }
  function start() {
    headerLink();
    productPage();
    renderFavoritesPage();
    scan();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
